import { Component, OnInit, Input, Optional } from '@angular/core';
import { FormGroup, ControlContainer, FormGroupDirective, AbstractControl, FormControl } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { CheckBoxOptions } from '../../Shared/Models/CheckBoxOptions';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ToggleSlideOptions } from '../../Shared/Models/ToggleslideOptions';

@Component({
  selector: 'BBSF-Toggleslide',
  templateUrl: './Toggleslide.component.html',
  styleUrls: ['./Toggleslide.component.scss']
})
export class ToggleslideComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public ToggleslideControlHost: FormGroupDirective) {
    ToggleslideComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: ToggleSlideOptions;
  ToggleslideFormControl: AbstractControl;
  SlideValue: boolean = false;



  ngOnInit() {

    this.group.addControl(this.options.Name, new FormControl(''));
    this.ToggleslideFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);
    let validationRules = [];
    let validationRulesasync = [];
    this.ToggleslideFormControl.setValue(this.options.Value);
    this.SlideValue = this.options.Value;
    if (this.options.IsDisabled) {
      this.ToggleslideFormControl.disable();
    }
    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);
  }


  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

  }

  resetError() {
    UtilityService.RemoveGlobalError();
  }

  getErrorValidation(Errorsitem: any[]): string {
    return this.controlUtility.getErrorValidation(Errorsitem, this.options.CustomValidation)
  }


  changeValueToggle() {
    this.ToggleslideFormControl.setValue(this.SlideValue)
  }
}
